import { useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const pollStatus = async (sessionId, attempts = 0) => {
  const maxAttempts = 6;
  if (attempts >= maxAttempts) {
    toast.error("No pudimos confirmar el pago. Revisa tu correo o inténtalo de nuevo.");
    return;
  }
  try {
    const { data } = await axios.get(`${API}/payments/checkout/status/${sessionId}`);
    if (data.payment_status === "paid") {
      toast.success(`¡Pago completado! Plan ${data.plan_name || ""} activado.`);
      return;
    }
    if (data.status === "expired") {
      toast.error("La sesión de pago expiró. Inténtalo de nuevo.");
      return;
    }
    setTimeout(() => pollStatus(sessionId, attempts + 1), 2000);
  } catch (e) {
    setTimeout(() => pollStatus(sessionId, attempts + 1), 2000);
  }
};

export const PaymentReturn = () => {
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (sessionId) {
      handled.current = true;
      toast.loading("Comprobando el estado del pago...", { duration: 2000 });
      pollStatus(sessionId);
      // Clean the session_id from the URL
      params.delete("session_id");
      const clean = window.location.pathname + (params.toString() ? `?${params}` : "");
      window.history.replaceState({}, "", clean);
    }
  }, []);

  return null;
};
